import { RichText } from '@/webapp/src/components/other/RichText/index.js'
import { SectionWrapper } from '@/webapp/src/lib/sectionWrapper.js'
import type { trpc as trpcType } from '@/webapp/src/lib/trpc.js'
import { Segment } from '@/webapp/src/lib/uninty.components.js'
import { formatDate } from 'date-fns'
import InfiniteScroll from 'react-infinite-scroller'

export const createPublicUpgradePostListPage =
  ({ trpc }: { trpc: typeof trpcType }) =>
  () => {
    return (
      <SectionWrapper
        useInfiniteQuery={() =>
          trpc.getUpgradePostsForPublic.useInfiniteQuery({}, { getNextPageParam: (lastPage) => lastPage.nextCursor })
        }
        setProps={({ infiniteQueryResult }) => ({
          upgradePosts: infiniteQueryResult.data?.pages.flatMap((page) => page.upgradePosts) ?? [],
          infiniteQueryResult,
        })}
      >
        {({ upgradePosts, infiniteQueryResult }) => {
          return (
            <InfiniteScroll
              threshold={250}
              loadMore={() => {
                if (!infiniteQueryResult.isFetchingNextPage && infiniteQueryResult.hasNextPage) {
                  void infiniteQueryResult.fetchNextPage()
                }
              }}
              hasMore={infiniteQueryResult.hasNextPage}
              loader={infiniteQueryResult.hasNextPage ? <p key="loader">Загрузка...</p> : undefined}
            >
              {upgradePosts.map((upgradePost) => {
                return (
                  <Segment
                    title={[upgradePost.desktopappVersion, upgradePost.title].join(' — ')}
                    size="xs"
                    key={upgradePost.id}
                    desc={formatDate(upgradePost.publishedAt, 'dd.MM.yyyy')}
                  >
                    <RichText html={upgradePost.contentHtml} />
                    <br />
                    <br />
                  </Segment>
                )
              })}
            </InfiniteScroll>
          )
        }}
      </SectionWrapper>
    )
  }
